import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { UniversalConfig } from '@application/universal_config.service';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { OutletPage } from '@old_patient_dependencies/outlet_page.component';
import { LocationSelectorService } from '@public/src/application/services/location_selector.service';
import { PatientFlowContainer } from '@public/src/components/patient_flow_container.component';
import { sharedResolution } from '@public/src/shared_resolution';
import { createRoot, Root } from 'react-dom/client';
import { Route, Routes } from 'react-router';
import { ViewRedRobin } from '../../../patient/src/views/view_red_robin/view_red_robin.component';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactRedRobinRedirectComponent';

@Component({
	standalone: false,
	selector: 'red-robin-forward-component',
	template: `
		<semantic-view hideOnMobile="true">
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class RedRobinWrapper implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;
	public extraHeaderHeight: boolean = false;

	constructor(private readonly ngZone: NgZone) {}

	ngOnChanges(_: SimpleChanges): void {
		// noop
	}

	ngAfterViewInit(): void {
		this.render();
	}

	ngOnDestroy(): void {
		this.root?.unmount();
	}

	private render(): void {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const split = locationSelectorService.location.route.split('/');
		split.splice(0, 1);
		const routeBase = split.join('/');

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<PatientFlowContainer>
						<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
							<Routes>
								<Route path={routeBase} element={<OutletPage padding='0px' />}>
									<Route path='triage/*' element={<ViewRedRobin />} />
								</Route>
							</Routes>
						</ProgrammaticBrowserRouter>
					</PatientFlowContainer>
				</CellulaProviderWrapper>,
			);
		});
	}
}
